<template>
    <div class="container-products-exlusive-units">
        <ui-card-exclusive-units />

        <ui-summary v-if="getHasSummary" />
    </div>
</template>

<script>
import uiCardExclusiveUnits from '@/components/ui-facilita/products/permissions/exclusive-units/card'
import uiSummary from '@/components/ui-facilita/products/permissions/exclusive-units/summary'
import { mapGetters } from 'vuex'

export default {
    name: 'products-exclusive-units',

    components: {
        uiCardExclusiveUnits,
        uiSummary
    },

    computed: {
        ...mapGetters('exclusiveManagement', [
            'getHasSummary'
        ])
    }
}
</script>

<style lang="stylus" scoped>
    @import './styles.styl'
</style>